// extracted by mini-css-extract-plugin
export var alignCenter = "_b7-d";
export var bannerShown = "_b7-6";
export var buttonContent = "_b7-0";
export var cardList = "_b7-1";
export var centerContent = "_b7-2";
export var chevron = "_b7-3";
export var closePanelButton = "_b7-k";
export var conversationContextContainer = "_b7-l";
export var conversationDetailContainer = "_b7-4";
export var detailWrapper = "_b7-7";
export var dropdownButton = "_b7-e";
export var dropdownTitle = "_b7-9";
export var fullHeight = "_b7-5";
export var hidden = "_b7-a";
export var icon = "_b7-b";
export var mergeSuggestionWrapper = "_b7-m";
export var panel = "_b7-i";
export var portalButtonsWrapper = "_b7-c";
export var right = "_b7-j";
export var tableSummaryContainer = "_b7-8";
export var tableSummaryHeader = "_b7-g";
export var threeDotsButton = "_b7-f";
export var wide = "_b7-h";